import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addBrand,
  addCategoryTypes,
  getAllBrands,
  getAllBrandsList,
  getCategoryTypes,
  getCategoryTypesNoLimit,
} from "../../../redux/features/assetManagementSlice";

const AddType = ({ dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const ValidationSchema = Yup.object().shape({
    category_type_name: Yup.string().required("Please add type name"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      category_type_name: "",
      is_returnable: false,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(addCategoryTypes({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          if (!dispatchParams) {
            dispatch(getCategoryTypesNoLimit());
          }
          dispatch(getCategoryTypes(dispatchParams));
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Add Type"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Add Type
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="category_type_name"
                    value={formik.values.category_type_name}
                    error={
                      formik.touched.category_type_name &&
                      Boolean(formik.errors.category_type_name)
                    }
                    helperText={formik.errors.category_type_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Type"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_returnable"
                        checked={formik.values.is_returnable}
                        onChange={formik.handleChange}
                      />
                    }
                    label="Is Returnable"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddType;
